
/* injects from baggage-loader */

CKEDITOR.plugins.setLang('fontweight','it', {
    title: 'Font Weight'
} );



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/fontweight/lang/it.js